<template>
  <div>
    <div v-if="alumnos[0]">
        <div v-for="(alumno, a) in alumnos" :key="a" style="overflow-x: auto;">
            <div class="widthBoletaStyle">
                <div>
                    <div class="d-flex">
                        <div style="width: 25%">
                        </div>
                        <div class="d-flex" style="width: 75%">
                            <template v-for="(cabecera, c) in alumno.header_periodos">
                                <div v-if="JSON.parse(persona).roles[0].name != 'Usuario Principal' ? true : verInfo[c].status == true" class="fontSix px-1 cabeceraTable" :class="'widthCabecera' + numCabecera" :key="c">
                                    <p style="hyphens: auto;">{{cabecera.periodo}} </p>
                                </div>
                            </template>
                        </div>
                    </div>
                    <template v-if="[1,2,3].includes(nivel)">
                        <template  v-if="alumno && alumno.materias_promediables && alumno.materias_promediables.campos_formativos && alumno.materias_promediables.campos_formativos.materias_sin_campo_formativo && alumno.materias_promediables.campos_formativos.materias_sin_campo_formativo[0]">
                            <div class="backgroundCampos mt-1" v-for="(mat, m) in alumno.materias_promediables.campos_formativos.materias_sin_campo_formativo" :key="m +'a'">
                                <div class="d-flex align-items-center">
                                    <div style="width: 25%; padding-left: 3px;">
                                        <p class="fontEight lineTogether"><span class="font-weight-bold">{{mat.materia}}</span> ({{mat.clave}})</p>
                                        <p class="fontSix lineTogether" style="text-transform: capitalize;">Docente: <span class="font-weight-bold text-capitalize">{{mat.docente}}</span></p>
                                    </div>
                                    <div class="d-flex" style="width: 75%" >
                                        <template v-for="(cal, ca) in mat.periodos">
                                            <div 
                                            :style="JSON.parse(persona).roles[0].name != 'Usuario Principal' && permisos.includes('modificar-calificaciones') ? 'cursor:pointer' : ''"
                                            v-if="JSON.parse(persona).roles[0].name != 'Usuario Principal' ? true : cal.detalle_componente_id == (verInfo[ca] && verInfo[ca].detalle)"
                                            :key="ca"
                                            class="fontEight px-1 cabeceraTable"
                                            :class="'widthCabecera' + numCabecera"
                                            @click="permisos.includes('modificar-calificaciones') ? getModificar(mat,cal, cal.conducta, 'conducta', a, ca, 'promediable') : ''">
                                                <p v-if="cal.conducta !== '' && cal.conducta !== null">{{cal.conducta == 0 ? '-' : cal.conducta}}</p>
                                                <p v-else>-</p>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <div :class="alumno.materias_promediables.materias != (m + 1) ? 'lineSeparador' : ''"></div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="backgroundCampos" v-for="(campo_formativo, cf) in alumno.materias_promediables.campos_formativos.materias_con_campo_formativo" :key="cf">
                                <div class="d-flex align-items-center">
                                    <div style="width: 25%">
                                        <p class="text-uppercase font-weight-bold fontNine" style="line-height: 1;">{{cf}}</p>
                                    </div>
                                </div>
                                <div v-for="(mat, m) in alumno.materias_promediables.campos_formativos.materias_con_campo_formativo[cf].materias" :key="m">
                                    <div class="d-flex align-items-center">
                                        <div style="width: 25%; padding-left: 3px;">
                                            <p class="fontEight lineTogether"><span class="font-weight-bold">{{mat.materia}}</span> ({{mat.clave}})</p>
                                            <p class="fontSix lineTogether" style="text-transform: capitalize;">Docente: <span class="font-weight-bold text-capitalize">{{mat.docente}}</span></p>
                                        </div>
                                        <div class="d-flex" style="width: 75%" >
                                            <template v-for="(cal, ca) in mat.periodos">
                                                <div
                                                :style="JSON.parse(persona).roles[0].name != 'Usuario Principal' && permisos.includes('modificar-calificaciones') ? 'cursor:pointer' : ''"
                                                v-if="JSON.parse(persona).roles[0].name != 'Usuario Principal' ? true : cal.detalle_componente_id == (verInfo[ca] && verInfo[ca].detalle)"
                                                :key="ca"
                                                class="fontEight px-1 cabeceraTable"
                                                :class="'widthCabecera' + numCabecera"
                                                @click="permisos.includes('modificar-calificaciones') ? getModificar(mat,cal, cal.conducta, 'conducta', a, ca, 'promediable') : ''">
                                                    <p v-if="cal.conducta !== '' && cal.conducta !== null">{{cal.conducta == 0 ? '-' : cal.conducta}}</p>
                                                    <p v-else>-</p>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <div :class="alumno.materias_promediables.campos_formativos.materias_con_campo_formativo[cf].materias.length != (m + 1) ? 'lineSeparador' : ''"></div>
                                </div>
                                <div class="lineSeparadorCampoFormativo"></div>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <div class="backgroundCampos" v-for="(mat, m) in alumno.materias_promediables.materias" :key="m + 'b'">
                            <div class="d-flex align-items-center">
                                <div style="width: 25%; padding-left: 3px;">
                                    <p class="fontEight lineTogether"><span class="font-weight-bold">{{mat.materia}}</span> ({{mat.clave}})</p>
                                    <p class="fontSix lineTogether" style="text-transform: capitalize;">Docente: <span class="font-weight-bold text-capitalize">{{mat.docente}}</span></p>
                                </div>
                                <div class="d-flex" style="width: 75%" >
                                    <template v-for="(cal, ca) in mat.periodos">
                                        <div
                                        :style="JSON.parse(persona).roles[0].name != 'Usuario Principal' && permisos.includes('modificar-calificaciones') ? 'cursor:pointer' : ''"
                                        v-if="JSON.parse(persona).roles[0].name != 'Usuario Principal' ? true : cal.detalle_componente_id == (verInfo[ca] && verInfo[ca].detalle)"
                                        :key="ca"
                                        class="fontEight px-1 cabeceraTable"
                                        :class="'widthCabecera' + numCabecera"
                                        @click="permisos.includes('modificar-calificaciones') ? getModificar(mat,cal, cal.conducta, 'conducta', a, ca, 'promediable') : ''">
                                            <p v-if="cal.conducta !== '' && cal.conducta !== null">{{cal.conducta == 0 ? '-' : cal.conducta}}</p>
                                            <p v-else>-</p>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div :class="alumno.materias_promediables.materias.length != (m + 1) ? 'lineSeparador' : ''"></div>
                        </div>
                        <div class="lineSeparadorCampoFormativo"></div>
                    </template>
                    <div style="background:#1B3966; height: 2px;"></div>
                    <div class="backgroundCampos" v-for="(mat, m) in alumno.materias_no_promediables" :key="m+1">
                        <div class="d-flex align-items-center">
                            <div style="width: 25%; padding-left: 3px;">
                                <p class="fontEight lineTogether"><span class="font-weight-bold">{{mat.materia}}</span><span v-if="mat.clave">({{mat.clave}})</span> </p>
                                <p v-if="mat.docente" class="fontSix lineTogether" style="text-transform: capitalize;">Docente: <span class="font-weight-bold text-capitalize">{{mat.docente}}</span></p>
                            </div>
                            <div class="d-flex" style="width: 75%" >
                                <template v-for="(cal, ca) in mat.periodos">
                                    <div
                                    :style="JSON.parse(persona).roles[0].name != 'Usuario Principal' && permisos.includes('modificar-calificaciones') ? 'cursor:pointer' : ''"
                                    v-if="JSON.parse(persona).roles[0].name != 'Usuario Principal' ? true : cal.detalle_componente_id == (verInfo[ca] && verInfo[ca].detalle)"
                                    :key="ca"
                                    class="fontEight px-1 cabeceraTable" :class="'widthCabecera' + numCabecera"
                                    @click="permisos.includes('modificar-calificaciones') ? getModificar(mat,cal, cal.conducta, 'conducta', a, ca, 'optativa') : ''">
                                        <p v-if="cal.conducta !== '' && cal.conducta !== null">{{cal.conducta == 0 ? '-' : cal.conducta}}</p>
                                        <p v-else>-</p>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="lineSeparadorCampoFormativo"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <modal-actualizar-calificacion v-model="activeCalificacion" :informacion="informacionCalificacion" :cicloEscolar="cicloEscolar" :institucion="institucion" @refreshTable="getRefreshTable"></modal-actualizar-calificacion>
  </div>
</template>

<script>
import ModalActualizarCalificacion from './modal/actualizar-calificacion.vue'
export default {
    props: ['nivel','alumnos', 'persona', 'permisos', 'forceRefresh', 'institucion', 'cicloEscolar'],
    data:() => ({
        tipo: 1,
        numCabecera: '',
        tipo_formato: '',
        verInfo: [],
        mostrar: false,
        force: 0,
        activeCalificacion: false,
        informacionCalificacion: {}
    }),
    components:{
        ModalActualizarCalificacion
    },
  methods: {
    getRefreshTable(){
        this.$emit("refreshTable")
    },
    getNumTotalCabecera(){
        const cabecera = this.alumnos[0].header_periodos
        const rol = 'administrador'
        const vm = this
        if(rol == 'administrador'){
            vm.numCabecera = cabecera.length
        }
    },
    getPeriodosShow(info){
        const arreglo = []
        const infor = this.alumnos[0].header_periodos
        infor.forEach(element => {
            let array = {}
            if(element.status_show_alumno == true){
                array = {
                    detalle: element.detalle_componente_id,
                    status: true
                }
            }else{
                array = {
                    nombre: false,
                    status: false
                }
            }
            arreglo.push(array)
        })
        this.verInfo = arreglo
    },
    async getCalificaciones (tipo) {
        if(this.alumnos[0]){
            this.tipo_formato = 'admin'
            const loading = this.$vs.loading({
                text: 'Por favor, espere. Esto puede tardar un poco.',
            })
            try {
                this.getNumTotalCabecera()
                this.getPeriodosShow()
                loading.close()
            } catch (error) {
                console.log(error)
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Error',
                    text: 'Hubo un error, favor de contactar al administrador.'
                })
                    
            }
        }
    },
    getModificar(infoG, calif, calificacion, tipo, index_materia, index_calificacion, tipoCalificacion){
        const persona = JSON.parse(this.persona)
        if(persona.roles[0].name != 'Usuario Principal'){
            this.activeCalificacion =! this.activeCalificacion
            this.informacionCalificacion ={
                "infoCalif": calif,
                "calificacionActual": calificacion,
                "infoCalifGen": infoG,
                "tipoModificar": tipo,
                "index_materia": index_materia,
                "index_calificacion": index_calificacion,
                "tipoCalificacion": tipoCalificacion
            }
        }
    },
  },
  watch: {
    alumnos(){
        this.getCalificaciones()
    }
  }
}
</script>

<style scoped>
.fontTen{
    font-size: 12px;
}
.fontSix{
    font-size: 13px;
}
.fontEight{
    font-size: 15px;
}
.fontNine{
    font-size: 16px;
}

.cabeceraTable{
    font-weight: 500;
    line-height: 1.5;
    text-align: center;
}

p{
    margin-bottom: 0;
}

.lineTogether {
    line-height: 1.5;
}

table tr th{
    font-size: 7px;
    margin: 0 2px;
}

.widthCabecera2{
    width: 50%;
}
.widthCabecera3{
    width: 33.3%;
}
.widthCabecera4{
    width: 25%;
}
.widthCabecera5{
    width: 20%;
}
.widthCabecera6{
    width: 16.6%;
}
.widthCabecera7{
    width: 14.28%;
}
.widthCabecera8{
    width: 12.5%;
}
.widthCabecera9{
    width: 11.11%;
}
.widthCabecera10{
    width: 10%;
}
.widthCabecera11{
    width: 9%;
}
.widthCabecera12{
    width: 8.33%;
}
.widthCabecera13{
    width: 7.69%;
}
.widthCabecera14{
    width: 7.14%;
}
.widthCabecera15{
    width: 6.66%;
}
.widthCabecera16{
    width: 6.25%;
}

.lineSeparadorCampoFormativo{
    width: 100%;
    height: 1px;
    background: #D9D9D9;
    margin: 2px 0;
}
.lineSeparador{
    width: 99.5%;
    height: 1px;
    background: #D9D9D9;
    margin: 2px 0 2px 0.5%;
}
.backgroundCampos:nth-last-child(even){
    background: rgba(217, 217, 217, 0.30);
}
.bottom-div {
    position: absolute;
    bottom: 0;
    width: 1240px;
    text-align: center;
}
</style>

